export const onPreRouteUpdate = () => {
    setTimeout(() => {
        document.getElementsByTagName("MAIN")[0].style.opacity = 1
    }, 100)
}